import Dummy from "components/Dummy";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import circleRight from "resources/img/puffu/main/circleRight.svg";
import videoFile from "resources/video/main.mp4";
import style from "./HorizontalMainView.module.css"
import loadingPoster from "resources/img/adLoadingCrop3.png"
import GLBModelViewer from "routes/3d/GLBModelViewer";
import RoundedButton from "../../process/Button/RoundedButton";
import AdBanner from "../../process/Button/AdBanner";


function MainCategoryBtn(props) {
    const {
        onPointerDown,
        onPointerUp,
        background,
        text1,
        text2,
        mainCategoryImg,
        imgWidth,
        color,
        ad,
        isDisabled,
        btnBackground,
        btnColor,
        vibrate,
        transY = 0,
    } = props;
    return (
        <div
            className={isDisabled ? null : style.btn}
            onPointerDown={onPointerDown}
            onPointerUp={onPointerUp}
            style={{
                background: background,
                boxShadow: ad ? null : "7px 10px 15px 0px rgba(0, 0, 0, 0.1)",
                border: ad && "none",
                height: "430px",
                borderRadius: "15px",
                touchAction: ad ? "none" : "auto"
            }
            }>
            {
                ad
                    ?
                    <div>
                    <div
                        style={{ overflow: "hidden", height: "430px", borderRadius: "15px" }}>
                            
                        <video autoPlay loop style={{ width: "100%", objectFit: "cover", height: "102%", borderRadius: "15px", border: "none" }} muted={true} poster={loadingPoster}>
                            <source style={{ border: "none" }} src={videoFile} type="video/mp4" />
                        </video>
                    </div>
                    <AdBanner></AdBanner>
                    </div>
                   

                    :

                    <HorizontalFlex padding={"30px"} flexStart>
                        <FlexChild height={"max-content"}>
                            <Center width={"100%"} textAlign={"left"}>



                                <P size={"2vw"} color={color ? color : "black"} weight={700}>{text1}</P>
                                <P size={"2vw"} color={color ? color : "black"} weight={700}>{text2}</P>



                                {/* <img src={circleRight} width={"20%"} style={{ filter: color ? null : "invert(100%)" }} /> */}
                                <RoundedButton
                                    text="자세히보기"
                                    textColor={btnColor}
                                    backgroundColor={btnBackground}
                                ></RoundedButton>

                            
                            </Center>
                        </FlexChild>
                        <FlexChild>

                            {
                                props.three
                                    ?
                                    props.three
                                :   <div style={{ transform: `translateY(${transY}px)` }}>
                                    <img className={`${vibrate ? style.vibrateHint : ''}`}  src={mainCategoryImg} width={imgWidth}/>
                                    </div>
                            }

                        </FlexChild>
                    </HorizontalFlex>

            }
        </div >
    );
}

export default MainCategoryBtn;